<!-- 预赛 -->
<template>
    <div class="stage-mod stage-final-playing">
        <div v-if="isFinishFinal" class="stage-box stage-box--empty">
            <div class="stage-box__msg">
                <dl>
                    <dd>{{finalBegin|time2text}} 至 {{finalEnd|time2text}} 决赛</dd>
                    <dd>你已完成决赛！</dd>
                    <dd>将于{{finalRes|time2text}}公布决赛成绩！</dd>
                </dl>
            </div>
            <van-button size="big" block type="danger" @click="view">查看纪录</van-button>
        </div>
        <div v-else-if="isAdvance" class="stage-box stage-box--empty">
            <div class="stage-box__msg">
                
                <dl>
                    <dd>{{finalBegin|time2text}} 至 {{finalEnd|time2text}}</dd>
                    <dd>决赛进行中，距离结束剩<span class="red">{{leftFor(finalEnd)}}</span></dd>
                    <dd></dd>
                </dl>
            </div>
            <van-button size="big" block type="danger" @click="play">参加决赛</van-button>
        </div>
        <div v-else-if="isValidUser" class="stage-box stage-box--empty">
            <div class="stage-box__msg">
                <dl>
                    <dd>{{finalBegin|time2text}} 至 {{finalEnd|time2text}} 决赛</dd>
                    <dd>很遗憾你没有晋级!</dd>
                    <dd>你可以体验擂台训练斗K！</dd>
                </dl>
            </div>
            <van-button size="big" block type="danger" @click="goTrialDK">前往斗K体验厅</van-button>
        </div>
        <div v-else class="stage-box stage-box--empty">
            <div class="stage-box__msg">
                <dl>
                    <dd>{{finalBegin|time2text}} 至 {{finalEnd|time2text}} 决赛</dd>
                    <dd class="red">决赛火热进行中</dd>
                    <dd>距离结束剩<span class="red">{{leftFor(finalEnd)}}</span></dd>
                </dl>
            </div>
            <van-button size="big" block type="danger" @click="play">参加决赛</van-button>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'final-playing',
        computed: {
            ...mapGetters(['isValidUser', 'leftFor', 'finalBegin', 'finalEnd', 'finalRes', 'finishCupNum',
                'allCupNum', 'isFinishFinal', 'isAdvance'
            ])
        },
        methods: {
            ...mapActions(['goLogin', 'goTrialDK', 'checkLogin']),
            view() {
                this.$router.push({
                    path: '/reality'
                })
            },
            async play() {
                const {
                    isValidUser
                } = this
                if (!isValidUser) {
                    await this.checkLogin()
                    this.goLogin()
                } else {
                    this.$router.push({
                        name: 'reality'
                    })
                }
                // if(isValidUser) {
                //     this.$router.push({
                //         name: 'reality'
                //     })
                // } else {
                //     this.$dialog.alert({
                //         title: '参赛提醒',
                //         message: '<div class="ta_left">尊敬的用户您好！<br>为保证您的比赛成绩留存及奖项核实发放，<span class="blue">验证手机号即可参与大赛</span>。</div>',
                //         // cancelButtonText: '取消',
                //         confirmButtonText: '验证手机号'
                //     }).then(() => {
                //         this.goLogin()
                //         // on confirm
                //     }).catch(() => {
                //         // on cancel
                //     });
                // }

            }
        }
    }

</script>
